import React from 'react';

const HText = ({ onKeyDown, role = 'definition', ...props }) => {
  const handleKeyDown = e => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.stopPropagation();
      onKeyDown(e);
    }
  };

  const { html } = props;
  if (html) {
    return (
      <div
        {...props}
        role={role}
        onKeyDown={handleKeyDown}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  } else {
    return <></>;
  }
};

export default HText;
